export default __webpack_public_path__ + "static/media/hht2_ep10_speaking_04.f469403f.png";